export default "__VITE_ASSET__D2vE4$ou__"